import React, { useEffect } from "react";
import { Modal, Form, Input } from "antd";
import {
  KlearlyAPKConfig,
  KlearlyAPKConfigVersion,
} from "../../../../interfaces/klearlyApkConfig.interface";

type VersionKey =
  | "fullVersion"
  | "liteVersion"
  | "liteSandboxVersion"
  | "iOSVersion"
  | "liteVersionPax"
  | "liteVersionSoftpay";

export default function ApkVersionEditorModal({
  open,
  versionKey,
  version,
  loading,
  onCancel,
  onSave,
}: {
  open: boolean;
  versionKey: VersionKey | null;
  version?: KlearlyAPKConfigVersion;
  loading: boolean;
  onCancel: () => void;
  onSave: (
    values: KlearlyAPKConfigVersion & { metadata_rapydCoreVersion?: string }
  ) => void;
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    form.setFieldsValue({
      name: version?.name,
      buildNumber: version?.buildNumber,
      fileUrl: version?.fileUrl,
      displayUrl: version?.displayUrl,
      metadata_rapydCoreVersion: version?.metadata?.rapydCoreVersion,
    });
  }, [open, version, form]);

  const DOWNLOADABLE_VERSIONS = [
    "fullVersion",
    "liteVersion",
    "liteSandboxVersion",
    "liteVersionSoftpay",
  ];

  return (
    <Modal
      title={version?.name ? `Edit ${version?.name}` : "Edit Version"}
      open={open}
      onOk={() => form.submit()}
      onCancel={onCancel}
      okButtonProps={{ loading }}
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={onSave}>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Build Number" name="buildNumber">
          <Input type="number" />
        </Form.Item>
        {DOWNLOADABLE_VERSIONS.includes(versionKey || "") && (
          <>
            <Form.Item label="Public URL" name="displayUrl">
              <Input />
            </Form.Item>
            <Form.Item
              label="File URL"
              name="fileUrl"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </>
        )}
        {versionKey === "liteVersionPax" && (
          <Form.Item
            label="Rapyd Core Version"
            name="metadata_rapydCoreVersion"
          >
            <Input placeholder="Optional. Only relevant for Lite Pax" />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
}
